import { useState, useRef } from 'react'
import PropTypes from 'prop-types'
import { Alert, Box, Button } from '@mui/material'

import { ReactComponent as MagnifyingGlass } from '../../../assets/icons/magnifying-glass.svg'

import useTranslations from '../../../i18n/useTranslations'
import SearchFieldNotDummy from '../../../ui/components/searchFieldNotDummy'
import { CODE_VALIDATION_FN } from '../../../common/constants'

import styles from './styles'

const SearchInput = ({ onSearch, onChangeInput, showNotFoundWarning }) => {
  const t = useTranslations()
  const buttonRef = useRef()

  const [isButtonDisabled, setIsButtonDisabled] = useState(true)

  const assessIsButtonDisabled = newInputValue => {
    const isDisabled = CODE_VALIDATION_FN(newInputValue)
    setIsButtonDisabled(isDisabled)
  }

  const handleChangeValue = newInputValue => {
    assessIsButtonDisabled(newInputValue)
    onChangeInput(newInputValue)
  }

  const handleClickSearchButton = () => buttonRef.current.onClick()

  return (
    <>
      <Box sx={styles.searchFieldWrapper}>
        <SearchFieldNotDummy
          ref={buttonRef}
          testId="shipment-tracking-input"
          label={t('home:shipment-locator-input-placeholder')}
          onChangeValue={handleChangeValue}
          onSearch={onSearch}
          showClearIcon
          helperText={t('home:shipment-locator-input-helper')}
        />
      </Box>

      <Alert
        severity="warning"
        aria-hidden={showNotFoundWarning ? null : true}
        sx={{ ...(showNotFoundWarning ? {} : styles.isHidden) }}
      >
        {t('home:no-results')}
      </Alert>

      <Button
        startIcon={<MagnifyingGlass />}
        onClick={handleClickSearchButton}
        disabled={isButtonDisabled}
        fullWidth
      >
        {t('action:search')}
      </Button>
    </>
  )
}

SearchInput.propTypes = {
  onSearch: PropTypes.func,
  onChangeInput: PropTypes.func,
  showNotFoundWarning: PropTypes.bool,
}

export default SearchInput
